export enum CirgsAgency {
  HEALTH_MINISTRY = '25000',
  FINANCE_MINISTRY = '17000',
  HEALTH_SURVEILLANCE = '36207',
  AGU = '40106',
  DECIP = '40806',
  INSS = '57202',
  CIRGS = '99999',
}
